import React from 'react';
import {
  BriefCaseOutLineIcon,
  ProfileUserIcon,
} from 'components/common/SVGIcon';
import theme from 'configs/theme';
import { useTranslation } from 'react-i18next';
import { TagUserTypeStyles } from './styles';

interface Props {
  userType: string;
}

const TagUserType = ({ userType }: Props) => {
  const { t } = useTranslation();
  const { Icon, text, primaryColor } = (() => {
    if (userType === 'parent') {
      return {
        Icon: ProfileUserIcon,
        text: 'common.parent',
        primaryColor: theme.palette.primary,
      };
    }
    return {
      Icon: BriefCaseOutLineIcon,
      text: 'common.jobSeeker',
      primaryColor: theme.palette.green,
    };
  })();

  return (
    <TagUserTypeStyles className="flex-center" $primaryColor={primaryColor}>
      <div>
        <Icon />
      </div>
      <div className="ml-6">{t(text)}</div>
    </TagUserTypeStyles>
  );
};

export default TagUserType;
